import Skeleton from "./Skeleton";

/**
 * A text-line placeholder that occupies the same vertical space real text
 * would: the bar is drawn at the glyph height (`fontSize`) but centered inside
 * a box the height of the real line box (`lineHeight`). Without reserving the
 * leading, every skeleton line sits `lineHeight - fontSize` too short and the
 * silhouette ends up more compact than the page it stands in for. Pass the DS
 * typography of the element being mirrored (e.g. title = 24/32, caption = 11/16).
 */
export default function SkeletonTextLine({
  width,
  fontSize,
  lineHeight,
}: {
  width: number | string;
  fontSize: number;
  lineHeight: number;
}): React.JSX.Element {
  return (
    <div className="flex items-center" style={{ height: `${lineHeight}px` }}>
      <Skeleton $variant="rectangular" width={width} height={fontSize} />
    </div>
  );
}
